import { Fragment, useContext, useState } from "react";
import { useNavigate } from "react-router";
import { Button } from "rizzui";
import { PrivilegeContext } from "../../../components/priviledge/PriviledgeProvider";
import { FiltersProvider } from "../../../components/providers/FiltersProvider";
import PageHeader from "../../../layout/shared/page-header";
import { menuRoutes } from "../../../router/menu";
import cn from "../../../utils/classNames";
import ClientsList from "./ClientsList";

const ClientsListWrapper = () => {

    // STATES

    const [openFormDrawer, setOpenFormDrawer] = useState<boolean>(false);
    const [clientSelected, setClientSelected] = useState<any | null>(null);

    const breadCrumb = [
        { name: 'Administración' },
        { name: 'Clientes', href: menuRoutes.clients.path }
    ];

    // HOOKS

    const { userCan } = useContext(PrivilegeContext);
    const navigate = useNavigate();

    // RENDER

    return (
        <Fragment>
            <FiltersProvider>
                <PageHeader title="Listado de clientes" breadcrumb={breadCrumb}>
                    {
                        userCan('create', 'client') &&
                        (
                            <Button
                                color="primary"
                                onClick={() => {
                                    setOpenFormDrawer(true)
                                    setClientSelected(null)
                                }}
                                className={cn(['mt-4 md:mt-0'])}
                            >
                                Crear cliente
                            </Button>
                        )
                    }
                </PageHeader>
                <ClientsList openFormDrawer={openFormDrawer} setOpenFormDrawer={setOpenFormDrawer} clientSelected={clientSelected} setClientSelected={setClientSelected} />
            </FiltersProvider>
        </Fragment>
    );
}

export default ClientsListWrapper;